module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.b351bd62abcd96e924d9.ttf";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/Material-Design-Iconic-Font.ttf?v=2.2.0
// module id = ../../../../../client/assets/fonts/Material-Design-Iconic-Font.ttf?v=2.2.0
// module chunks = styles